var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"security-title"},[_vm._v(_vm._s(_vm.$t('ActionTrailSecurity.title')))]),_vm._v(" "),_c('div',{staticClass:"security-top"},[_c('security-search')],1),_vm._v(" "),_c('table-security')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04d9c7ff","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/monitor/logs/security/Security.vue
// module id = umIr
// module chunks = 0